import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import ModalKeys from "../../../const/ModalKeys";
import Div from "../../common/ui/Div";
import { TextBlock } from "../../common/ui/Text";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { SpacingHeight } from "../../common/ui/Spacing";
import { IconCircleFilledIcon } from "../../common/ui/Icon";
import AppTheme from "../../../service/app_config/AppTheme";
import Center from "../../common/ui/Center";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import { LogoRound } from "../../common/ui/Logo";
import { textCase } from "../../../service/ui/UI";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { navigate } from "../../../service/navigation/Navigation";
import { appRoutes } from "../../../routes/routes";
import SocketService, { socket } from "../../../service/socket/SocketService";
import SocketChatsKeys from "../../../const/SocketChatsKeys";
import Loader from "../../common/ui/Loader";
import { ConversationList } from "../../../model/chats/ChatListModel";
import { useDispatch } from "react-redux";
import {
  addModal,
  removeAllModal,
  removeModal,
} from "../../../libraries/state_reducers/widget/ModalsReducer";
import { updateDeptChat } from "../../../libraries/state_reducers/widget/DetailConnectDeptTeamReducer";
import { chatRefreshListStatus } from "../../../libraries/state_reducers/chats/ChatsReducer";
import ShowToast from "../../common/ui/Toast";
import CacheStorage from "../../../service/storage/CacheStorage";
import AppConfigService from "../../../service/app_config/AppConfigService";

type ConnectProps = {
  modalId: string;
};

const DetailConnectDeptTeam: React.FC<ConnectProps> = ({ modalId }) => {
  const type: number = ResponsiveDeviceType();

  const dispatch = useDispatch();

  const detailDeptChat = useSelector(
    (state: RootState) => state.detailConnectDeptChat.detailDeptChat
  );
  const detailTeam = useSelector(
    (state: RootState) => state.detailConnectDeptChat.detailTeam
  );
  const detailSearchTeam = useSelector(
    (state: RootState) => state.detailConnectDeptChat.detailSearchTeam
  );
  const detailChatGroupTeam = useSelector(
    (state: RootState) => state.detailConnectDeptChat.detailChatGroupTeam
  );

  const [teamName, setTeamName] = useState<string>("");
  const [teamTitle, setTeamTitle] = useState<string>("");
  const [teamLogo, setTeamLogo] = useState<string>("");

  const [branchName, setBranchName] = useState<string>("");
  const [branchLogo, setBranchLogo] = useState<string>("");
  const [contactNumber, setContactNumber] = useState<string>("");

  const initDeptData = () => {
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    const branchLogoSession: string = CacheStorage.getValue(
      StorageKeys.branch_logo
    );

    setBranchName(branchNameSession);
    setBranchLogo(branchLogoSession);

    if (detailDeptChat != null) {
      if (UtilityHelper.isNotEmpty(detailDeptChat?.phone_number!)) {
        setContactNumber(
          `${detailDeptChat?.phone_code!}${detailDeptChat?.phone_number!}`
        );
      }
    }
  };

  const intTeamData = () => {
    if (detailTeam != null) {
      setTeamName(detailTeam?.name!);
      setTeamLogo(detailTeam?.logo_url!);
      setTeamTitle(detailTeam?.title!);

      if (UtilityHelper.isNotEmpty(detailTeam?.mobile_no!)) {
        setContactNumber(
          `${detailTeam?.mobile_code!}${detailTeam?.mobile_no!}`
        );
      }
    }

    if (detailSearchTeam != null) {
      setTeamName(detailSearchTeam?.name!);
      setTeamLogo(detailSearchTeam?.logo_url!);
      setTeamTitle(detailSearchTeam?.title!);
    }

    if (detailChatGroupTeam != null) {
      setTeamName(detailChatGroupTeam?.name!);
      setTeamLogo(detailChatGroupTeam?.logo_url!);
      setTeamTitle(detailChatGroupTeam?.title!);

      if (UtilityHelper.isNotEmpty(detailChatGroupTeam?.mobile_no!)) {
        setContactNumber(
          `${detailChatGroupTeam?.mobile_code!}${detailChatGroupTeam?.mobile_no!}`
        );
      }
    }
  };

  const navigateTo = async (detail: any, fromChat: boolean = false) => {
    dispatch(removeAllModal());

    Loader.modal(false);
    const flag: string = detail["flag"] ?? "0";

    let conversDetail: ConversationList = {};

    if (modalId === ModalKeys.connect_detail_branch_depts_chat) {
      conversDetail = {
        conv_id: detail["conv_id"],
        flag: detail["flag"],
        account_id: detail["department_id"],
        account_type: "4",
        name: detail["name"],
        title: detail["title"],
        logo: detail["logo"],
        unread_count: detail["conv_settings"]["unread_count"],
        conv_settings: {
          unread_count: detail["conv_settings"]["unread_count"],
          mute_status:
            detail["conv_settings"]["muted_conversations"]["mute_status"],
        },
      };
    } else {
      conversDetail = {
        conv_id: detail["conv_id"],
        flag: detail["flag"],
        account_id: detail["participant_details"]["account_id"],
        account_type: detail["participant_details"]["account_type"],
        name: detail["participant_details"]["name"],
        title: detail["participant_details"]["title"],
        logo: detail["participant_details"]["logo"],
        unread_count: detail["conv_settings"]["unread_count"],
        conv_settings: {
          unread_count: detail["conv_settings"]["unread_count"],
          mute_status:
            detail["conv_settings"]["muted_conversations"]["mute_status"],
        },
      };
    }

    SessionStorage.saveValue(
      StorageKeys.chats_chat_selected,
      JSON.stringify(conversDetail)
    );

    SessionStorage.saveValue(StorageKeys.chats_popup_connect, "1");

    if (fromChat) {
      if (type < 3) {
        if (["1", "4"].includes(flag)) {
          navigate(appRoutes.routeNameChatTeam, { replace: true });
        } else if (flag === "2") {
          navigate(appRoutes.routeNameChatDepartment, { replace: true });
        }
      } else {
        dispatch(chatRefreshListStatus(true));
      }
    } else {
      navigate(appRoutes.routeNameChats);
      if (type < 3) {
        if (["1", "4"].includes(flag)) {
          navigate(appRoutes.routeNameChatTeam);
        } else if (flag === "2") {
          navigate(appRoutes.routeNameChatDepartment);
        }
      }
    }
  };

  const onClickConnect = async () => {
    let connectStatus: boolean = false;
    if (
      detailTeam != null ||
      detailDeptChat != null ||
      detailSearchTeam != null ||
      detailChatGroupTeam != null
    ) {
      if (!socket.connected) {
        Loader.modal();
        connectStatus = await SocketService.initialize();
        await UtilityHelper.delay();
        Loader.modal(false);
      } else {
        connectStatus = true;
      }
    }

    if (connectStatus) {
      if (modalId === ModalKeys.connect_detail_branch_team) {
        if (detailTeam != null) {
          Loader.modal();
          await SocketService.initConversation({
            flag: "1",
            eventN: SocketChatsKeys.check_team_contact_request,
            profId: detailTeam.account_id,
            branchId: CacheStorage.getValue(StorageKeys.branch_id) || "0",
            callback: async (response: any) => {
              console.log(response);
              if (response["status"] === "1") {
                navigateTo(response["results"]);
              } else {
                Loader.modal(false);
                ShowToast.info(response["message"] ?? "");
              }
            },
          });
        }

        if (detailSearchTeam != null) {
          Loader.modal();
          await SocketService.initConversation({
            flag: "1",
            eventN: SocketChatsKeys.check_team_contact_request,
            profId: detailSearchTeam.account_id,
            branchId: detailSearchTeam?.branch_id,
            callback: async (response: any) => {
              console.log(response);
              if (response["status"] === "1") {
                navigateTo(response["results"]);
              } else {
                Loader.modal(false);
                ShowToast.info(response["message"] ?? "");
              }
            },
          });
        }

        if (detailChatGroupTeam != null) {
          Loader.modal();
          await SocketService.initConversation({
            flag: "1",
            eventN: SocketChatsKeys.check_team_contact_request,
            profId: detailChatGroupTeam.account_id,
            branchId: detailChatGroupTeam?.branch_id,
            callback: async (response: any) => {
              console.log(response);
              if (response["status"] === "1") {
                navigateTo(response["results"], true);
              } else {
                Loader.modal(false);
                ShowToast.info(response["message"] ?? "");
              }
            },
          });
        }
      } else if (modalId === ModalKeys.connect_detail_branch_depts_chat) {
        if (detailDeptChat != null) {
          if ((detailDeptChat.chat_access_type ?? "0") === "0") {
            Loader.modal();
            await SocketService.initConversation({
              flag: "2",
              eventN: SocketChatsKeys.check_dept_contact_request,
              profId: detailDeptChat.chat_id,
              branchId: CacheStorage.getValue(StorageKeys.branch_id) || "0",
              callback: async (response: any) => {
                console.log(response);
                if (response["status"] === "1") {
                  navigateTo(response["results"]);
                } else {
                  Loader.modal(false);
                  ShowToast.info(response["message"] ?? "");
                }
              },
            });
          }
        }
      }
    }
  };

  const connectDeptChat = () => {
    if (detailDeptChat != null) {
      console.log(detailDeptChat.chat_access_type);
      if ((detailDeptChat.chat_access_type ?? "0") === "0") {
        onClickConnect();
      } else {
        dispatch(removeModal(ModalKeys.connect_detail_branch_depts_chat));
        dispatch(updateDeptChat(detailDeptChat));
        dispatch(
          addModal({
            id: ModalKeys.connect_detail_branch_depts_restrict,
            title: detailDeptChat?.chat_title!,
            size: "md",
            hideHeader: true,
          })
        );
      }
    }
  };

  useEffect(() => {
    if (modalId === ModalKeys.connect_detail_branch_depts_chat) {
      initDeptData();
    } else {
      intTeamData();
    }

    return () => {
      if (socket.connected) {
        SocketService.disconnect();
        console.log(`socket disconnect - TEAM/DEPT popup connect`);
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Div className={`pt-4 pb-${type === 3 ? 1 : 3}`}>
      {modalId === ModalKeys.connect_detail_branch_depts_chat ? (
        <Div>
          <Center>
            <LogoRound
              url={branchLogo || AppConfigService.get("company_logo")}
              size={type !== 2 ? 100 : 180}
              name={branchName}
            />
          </Center>
          <SpacingHeight value={type === 1 ? 40 : 50} />
          <TextBlock
            center={true}
            fontSize="20_21"
            fontName="bold"
            textColor="theme-label"
          >
            {textCase(detailDeptChat?.chat_title!)}
          </TextBlock>
        </Div>
      ) : (
        <Div>
          <Center>
            <LogoRound
              url={teamLogo}
              size={type !== 2 ? 100 : 180}
              name={teamName}
              bgHexColor={AppTheme.primary}
            />
          </Center>
          <SpacingHeight value={type === 1 ? 40 : 50} />
          <TextBlock
            center={true}
            fontSize="20_21"
            fontName="bold"
            textColor="theme-label"
          >
            {textCase(teamName)}
          </TextBlock>
          <SpacingHeight value={type === 1 ? 5 : 10} />
          <TextBlock
            center={true}
            fontSize="16_17"
            fontName="book"
            textColor="theme-ublabel"
          >
            {textCase(teamTitle)}
          </TextBlock>
        </Div>
      )}

      {UtilityHelper.isNotEmpty(contactNumber) && (
        <>
          <SpacingHeight value={type === 1 ? 5 : 10} />
          <TextBlock
            center={true}
            fontSize="16_17"
            fontName="book"
            textColor="green3"
            className="dir-ltr"
          >
            {textCase(contactNumber)}
          </TextBlock>
        </>
      )}

      <SpacingHeight value={UtilityHelper.isEmpty(contactNumber) ? 30 : 50} />

      <Center>
        <div
          role="button"
          onClick={() => {
            modalId === ModalKeys.connect_detail_branch_depts_chat
              ? connectDeptChat()
              : onClickConnect();
          }}
        >
          <Center>
            <IconCircleFilledIcon
              name="switch"
              size={type === 1 ? 50 : 65}
              color={AppTheme.themeFont}
            />
          </Center>
          <SpacingHeight value={15} />
          <TextBlock
            fontName={type === 3 ? "book" : "medium"}
            fontSize="14_15"
            textColor="theme-label"
            center={true}
          >
            {AppTranslation.text("connect")}
          </TextBlock>
        </div>
      </Center>
    </Div>
  );
};

export default DetailConnectDeptTeam;
